import { useState, useEffect } from 'react';
import { TStoreListDetail } from '@/types';

export default function useNearStores() {
  const [nearStores, setnearStores] = useState<TStoreListDetail[]>([]);
  const [mostNearStore, setMostNearStore] = useState<TStoreListDetail>();

  useEffect(() => {
    const sortNearBy = nearStores.sort((a, b) => {
      const distanceA = a.distance_desc?.includes('km')
        ? Number(a.distance_desc.split('km')[0]) * 1000
        : Number(a.distance_desc?.split('m')[0]);
      const distanceB = b.distance_desc?.includes('km')
        ? Number(b.distance_desc.split('km')[0]) * 1000
        : Number(b.distance_desc?.split('m')[0]);
      return distanceA - distanceB;
    });
    setMostNearStore(sortNearBy.filter(item => item.store_type === 1)[0]);
  }, [nearStores]);

  return { nearStores, setnearStores, mostNearStore };
}
